import RuleTypeTable from './RuleTypeTable';

export default RuleTypeTable;
